module.exports = __webpack_public_path__ + "static/media/background.abb9919d.jpg";